// extracted by mini-css-extract-plugin
module.exports = {"hero":"Home_hero__EW7yu"};